module.exports = __webpack_public_path__ + "img/SEND_MESSAGE.1f995ee0.svg";